// TODO: Revert once styled-components are removed from money

'use client';

import { MoneyBlocks } from '@benzinga/money';
import type { Block } from '@benzinga/content-manager';

interface MoneyBlocksClientProps {
  blocks: Block[];
  disallowLazyLoadBlockList?: string[];
  lazyLoadEnabled?: boolean;
  lazyLoadStartIndex?: number;
}

export function MoneyBlocksClient({
  blocks,
  disallowLazyLoadBlockList,
  lazyLoadEnabled,
  lazyLoadStartIndex,
}: MoneyBlocksClientProps) {
  return (
    <MoneyBlocks
      blocks={blocks}
      disallowLazyLoadBlockList={disallowLazyLoadBlockList}
      lazyLoadEnabled={lazyLoadEnabled}
      lazyLoadStartIndex={lazyLoadStartIndex}
    />
  );
}
